<div class="form-modal modal-theme">
    <h1 mat-dialog-title>{{title|translate}}</h1>
    <div mat-dialog-content>
      <div class="form-horizontal">
        <div class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12">
                <table id="table-listDropdown" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th rowspan="2"></th>
                      <th>
                        <strong>{{ 'CODE' | translate }}</strong>
                      </th>
                      <th>
                        <strong>{{ 'NAME_DENOMINATION' | translate }}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput" [(ngModel)]="codeFilter">
                        </mat-form-field>
                      </th>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput" [(ngModel)]="nameFilter">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      
      <div class="full-width text-right">
        <button *ngIf="allowClean" type="button" class="btn btn-default" title="{{'BUTTON.CLEAR_SELECTION' | translate}}" (click)="dialogRef.close('')">
          {{'BUTTON.CLEAR_SELECTION' | translate}}
        </button>  
      
        <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
          {{'BUTTON.CANCEL' | translate}}
        </button>  
      </div>
    </div>
  </div>